
/**
 * Recorrer un arreglo en pares
 * Tomado de https://stackoverflow.com/a/31973533/3384529
 * @param arr
 * @param func
 */
export function pairwise(arr, func){
  for(var i=0; i < arr.length - 1; i++){
      func(arr[i], arr[i + 1])
  }
}
